'use strict';

module.exports = {
  phone: ['(99) 9 9999-9999', '+99 (99) 9 9999-9999'],
  zipcode: '99999-999',
  cpf: '999.999.999-99',
  rg: '99.999.999-9',
  date: '99/99/9999'
};
